export default [
  {
    path: '/app/teams',
    name: 'Teams',
    component: () => import('@/views/Teams/Index.vue'),
    meta: {
      pageTitle: 'Ekipler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'TEAM_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/teams/add',
    name: 'TeamsAdd',
    component: () => import('@/views/Teams/Add.vue'),
    meta: {
      pageTitle: 'Ekipler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/teams',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'TEAM_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/teams/edit/:id',
    name: 'TeamsEdit',
    component: () => import('@/views/Teams/Edit.vue'),
    meta: {
      pageTitle: 'Ekipler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/teams',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'TEAM_EDIT',
      action: 'read',
    },
  },
]
